// POST Subscriptions
export const POST_SUBSCRIPTION_REQUEST = "POST_SUBSCRIPTION_REQUEST";
export const POST_SUBSCRIPTION_SUCCESS = "POST_SUBSCRIPTION_SUCCESS";
export const POST_SUBSCRIPTION_FAILURE = "POST_SUBSCRIPTION_FAILURE";
export const POST_SUBSCRIPTION_RESET = "POST_SUBSCRIPTION_RESET";

// POST Extractor Subscriptions
export const POST_EXTRACTOR_SUBSCRIPTION_REQUEST = "POST_EXTRACTOR_SUBSCRIPTION_REQUEST";
export const POST_EXTRACTOR_SUBSCRIPTION_SUCCESS = "POST_EXTRACTOR_SUBSCRIPTION_SUCCESS";
export const POST_EXTRACTOR_SUBSCRIPTION_FAILURE = "POST_EXTRACTOR_SUBSCRIPTION_FAILURE";
export const POST_EXTRACTOR_SUBSCRIPTION_RESET = "POST_EXTRACTOR_SUBSCRIPTION_RESET";

// List Subscriptions
export const FETCH_SUBSCRIPTION_LIST_REQUEST = "FETCH_SUBSCRIPTION_LIST_REQUEST";
export const FETCH_SUBSCRIPTION_LIST_SUCCESS = "FETCH_SUBSCRIPTION_LIST_SUCCESS";
export const FETCH_SUBSCRIPTION_LIST_FAILURE = "FETCH_SUBSCRIPTION_LIST_FAILURE";
export const FETCH_SUBSCRIPTION_LIST_RESET = "FETCH_SUBSCRIPTION_LIST_RESET";

//Delete Subscriptions
export const DELETE_SUBSCRIPTION_SUCCESS = "DELETE_SUBSCRIPTION_SUCCESS";
export const DELETE_SUBSCRIPTION_REQUEST = "DELETE_SUBSCRIPTION_REQUEST";
export const DELETE_SUBSCRIPTION_FAILURE = "DELETE_SUBSCRIPTION_FAILURE";
export const DELETE_SUBSCRIPTION_RESET = "DELETE_SUBSCRIPTION_RESET";